/* WFW COLLECTION EXPRESS PIN START */
(function () {
  'use strict';

  if (document.documentElement.classList.contains('h-ab-live')) return;

  var PIN_KEY = 'ExistPincode';
  var ROOT_SEL = '[data-collection-express-pin]';
  var FEATURE_NAME = 'pincode';
  var FEATURE_ID = 'filter';

  function isValidPin(pin) {
    return /^\d{6}$/.test(String(pin || '').trim());
  }

  function normalizePin(pin) {
    return String(pin || '')
      .replace(/\D/g, '')
      .slice(0, 6);
  }

  function readStoredPin() {
    var api = window.WFWDeliverySlaApi;
    if (api && typeof api.getPincode === 'function') {
      var fromApi = api.getPincode();
      if (isValidPin(fromApi)) return String(fromApi).trim();
    }
    try {
      var stored = localStorage.getItem(PIN_KEY);
      if (isValidPin(stored)) return String(stored).trim();
    } catch (e) {}
    return null;
  }

  function persistPin(pin) {
    var normalized = normalizePin(pin);
    if (!isValidPin(normalized)) return false;

    var api = window.WFWDeliverySlaApi;
    if (api && typeof api.setPincode === 'function') {
      return !!api.setPincode(normalized);
    }

    try {
      localStorage.setItem(PIN_KEY, normalized);
    } catch (e) {}
    document.dispatchEvent(
      new CustomEvent('wfw:pincode-updated', { detail: { pincode: normalized } })
    );
    return true;
  }

  function featureTags() {
    return {
      name: FEATURE_NAME,
      id: FEATURE_ID,
      strategyId: FEATURE_ID,
      variant: 'variant',
      source: 'custom-liquid',
      sectionId: 'collection-express-pin',
    };
  }

  function stampFeatureParams() {
    var tags = featureTags();
    var tracking = window.HeliumUtils && window.HeliumUtils.tracking;
    if (tracking && typeof tracking.appendFeatureParams === 'function') {
      try {
        var next = tracking.appendFeatureParams(window.location.href, tags);
        if (next && next !== window.location.pathname + window.location.search + window.location.hash) {
          window.history.replaceState({}, '', next);
        }
      } catch (e) {}
    }
  }

  function cacheEls(root) {
    return {
      root: root,
      idle: root.querySelector('[data-express-pin-view="idle"]'),
      edit: root.querySelector('[data-express-pin-view="edit"]'),
      set: root.querySelector('[data-express-pin-view="set"]'),
      input: root.querySelector('#collection-express-pin-input'),
      value: root.querySelector('[data-express-pin-value]'),
      error: root.querySelector('[data-express-pin-error]'),
    };
  }

  function setMode(ui, mode) {
    var views = { idle: ui.idle, edit: ui.edit, set: ui.set };
    Object.keys(views).forEach(function (key) {
      if (!views[key]) return;
      if (key === mode) views[key].removeAttribute('hidden');
      else views[key].setAttribute('hidden', '');
    });
    ui.root.setAttribute('data-express-pin-mode', mode);
    hideError(ui);
  }

  function showError(ui, message) {
    if (!ui.error) return;
    ui.error.textContent = message || '';
    ui.error.hidden = !message;
  }

  function hideError(ui) {
    showError(ui, '');
  }

  function paintSet(ui, pin) {
    if (ui.value) ui.value.textContent = pin;
    if (ui.input) ui.input.value = pin;
    ui.root.setAttribute('data-express-pin-current', pin);
    setMode(ui, 'set');
  }

  function paintIdle(ui) {
    ui.root.removeAttribute('data-express-pin-current');
    if (ui.input) ui.input.value = '';
    setMode(ui, 'idle');
  }

  function openEdit(ui, existing) {
    setMode(ui, 'edit');
    if (ui.input) {
      ui.input.value = existing || '';
      window.requestAnimationFrame(function () {
        ui.input.focus();
        ui.input.select();
      });
    }
  }

  function saveFromInput(ui) {
    var pin = normalizePin(ui.input && ui.input.value);
    if (ui.input && ui.input.value !== pin) ui.input.value = pin;
    if (!isValidPin(pin)) {
      showError(ui, 'Please enter a valid 6 digit pincode');
      return false;
    }
    if (window.WfwExpressTrack) window.WfwExpressTrack.pin(pin, 'collection_pin');
    if (!persistPin(pin)) {
      showError(ui, 'Could not save pincode. Try again.');
      return false;
    }
    paintSet(ui, pin);
    stampFeatureParams();
    return true;
  }

  function bind(root) {
    if (!root || root.getAttribute('data-express-pin-ready') === '1') return;
    root.setAttribute('data-express-pin-ready', '1');

    var ui = cacheEls(root);
    if (!ui.input) return;

    var stored = readStoredPin();
    if (stored) paintSet(ui, stored);
    else paintIdle(ui);

    root.addEventListener('click', function (event) {
      var btn = event.target.closest('[data-express-pin-action]');
      if (!btn || !root.contains(btn)) return;
      var action = btn.getAttribute('data-express-pin-action');
      if (action === 'open' || action === 'change') {
        openEdit(ui, ui.root.getAttribute('data-express-pin-current') || '');
      } else if (action === 'save') {
        saveFromInput(ui);
      } else if (action === 'cancel') {
        var current = ui.root.getAttribute('data-express-pin-current');
        if (isValidPin(current)) paintSet(ui, current);
        else paintIdle(ui);
      }
    });

    ui.input.addEventListener('input', function () {
      var pin = normalizePin(ui.input.value);
      if (ui.input.value !== pin) ui.input.value = pin;
      hideError(ui);
      if (pin.length === 6) saveFromInput(ui);
    });

    ui.input.addEventListener('keydown', function (event) {
      if (event.key === 'Enter') {
        event.preventDefault();
        saveFromInput(ui);
      } else if (event.key === 'Escape') {
        var current = ui.root.getAttribute('data-express-pin-current');
        if (isValidPin(current)) paintSet(ui, current);
        else paintIdle(ui);
      }
    });

    document.addEventListener('wfw:pincode-updated', function (event) {
      if (ui.root.getAttribute('data-express-pin-mode') === 'edit' && document.activeElement === ui.input) {
        return;
      }
      var next =
        event && event.detail && isValidPin(event.detail.pincode)
          ? String(event.detail.pincode).trim()
          : readStoredPin();
      if (next) paintSet(ui, next);
      else paintIdle(ui);
    });
  }

  /* Card badges â€” w-express-badge.svg when any in-stock SKU is under 24h */
  var API_BASE = window.WfwDeliveryStatusUrl;
  /* LIVE status host is snippets/delivery-status-url.liquid
  var API_BASE = 'https://impulse-backend.heliumbuilder.com/api/delivery/status';
  */
  var SHOP_DOMAIN = 'shopforw.myshopify.com';
  var SKU_CHUNK = 60;
  var COALESCE_MS = 400;
  var CACHE_TTL = 5 * 60 * 1000;
  var SESSION_SKU_PREFIX = 'WfwSkuStatus:v2:';
  var badgeRun = 0;
  var badgeTimer = 0;
  var badgeRunning = false;
  var badgeAgain = false;
  var gridQuiet = 0;
  var chunkFlights = {};
  var cardObserver = null;
  var pendingSkus = new Set();

  function skuKey(pin, sku) {
    return String(pin) + '::' + String(sku);
  }

  function readSkuCache(pin, sku) {
    var key = SESSION_SKU_PREFIX + skuKey(pin, sku);
    try {
      var raw = sessionStorage.getItem(key);
      if (!raw) return null;
      var parsed = JSON.parse(raw);
      if (!parsed || Date.now() - parsed.ts >= CACHE_TTL) {
        sessionStorage.removeItem(key);
        return null;
      }
      if (parsed.checked === true || parsed.value) return parsed;
      sessionStorage.removeItem(key);
      return null;
    } catch (e) {
      return null;
    }
  }

  function writeSkuCache(pin, sku, value) {
    try {
      sessionStorage.setItem(
        SESSION_SKU_PREFIX + skuKey(pin, sku),
        JSON.stringify({ ts: Date.now(), checked: true, value: value || null })
      );
    } catch (e) {}
  }

  function cardSkus(card) {
    return String(card.getAttribute('data-delivery-skus') || '')
      .split(',')
      .map(function (s) {
        return String(s || '').trim();
      })
      .filter(Boolean);
  }

  function isExpressHours(info) {
    if (!info) return false;
    var type = String(info.deliveryType || '');
    if (type === 'SDD' || type === 'NDD') return true;
    var hours = Number(info.totalHours);
    return isFinite(hours) && hours <= 48;
  }

  function cardVariants(card) {
    return String(card.getAttribute('data-delivery-variants') || '')
      .split('||')
      .map(function (part) {
        var bits = String(part || '').split('~');
        if (!bits[0] || bits.length < 3) return null;
        return { sku: bits[0], size: bits[1], id: bits[2] };
      })
      .filter(Boolean);
  }

  function productPath(card) {
    var link = card.querySelector('a.card-information__text');
    if (!link) return '';
    return String(link.getAttribute('href') || '').split('?')[0];
  }

  function escapeHtml(value) {
    return String(value)
      .replace(/&/g, '&amp;')
      .replace(/</g, '&lt;')
      .replace(/>/g, '&gt;')
      .replace(/"/g, '&quot;');
  }

  var DELIVERY_MONTHS = [
    'January', 'February', 'March', 'April', 'May', 'June',
    'July', 'August', 'September', 'October', 'November', 'December'
  ];

  function formatDeliveryDate(iso) {
    // WFW CLP RELATIVE DELIVERY START
    // Added only: rollback by removing this marked block; the original formatter below is unchanged.
    var api = window.WFWDeliverySlaApi;
    var relative = api && typeof api.relativeDeliveryDay === 'function' ? api.relativeDeliveryDay(iso) : '';
    if (relative) return 'Delivery ' + relative;
    // WFW CLP RELATIVE DELIVERY END
    var parts = String(iso || '').split('-');
    if (parts.length < 3) return '';
    var month = Number(parts[1]);
    var day = Number(parts[2]);
    if (!month || month > 12 || !day) return '';
    return DELIVERY_MONTHS[month - 1] + ' ' + day;
  }

  function earliestExpressDate(variants, statusMap) {
    var earliest = '';
    variants.forEach(function (variant) {
      var info = statusMap[variant.sku];
      var iso = info && info.estimatedDeliveryDate;
      if (!iso) return;
      if (!earliest || String(iso) < earliest) earliest = String(iso);
    });
    return formatDeliveryDate(earliest);
  }

  function cardIntersectsViewport(card) {
    if (!card || !card.getBoundingClientRect) return false;
    var rect = card.getBoundingClientRect();
    if (rect.width < 1 && rect.height < 1) return false;
    return rect.bottom > 0 && rect.top < window.innerHeight && rect.right > 0 && rect.left < window.innerWidth;
  }

  function gridCards() {
    var scoped = document.querySelectorAll('#product-grid .card-wrapper[data-delivery-skus], .product-grid .card-wrapper[data-delivery-skus]');
    if (scoped.length) return Array.from(scoped);
    return Array.from(document.querySelectorAll('.card-wrapper[data-delivery-skus]'));
  }

  function screenNeedsFetch(known) {
    return gridCards().some(function (card) {
      if (!cardIntersectsViewport(card)) return false;
      return cardSkus(card).some(function (sku) {
        return !known.has(sku) && !pendingSkus.has(sku);
      });
    });
  }

  function pushMissingSku(missing, seen, known, sku) {
    if (missing.length >= SKU_CHUNK) return;
    if (!sku || seen.has(sku) || known.has(sku) || pendingSkus.has(sku)) return;
    seen.add(sku);
    missing.push(sku);
  }

  function missingFromScreen(known) {
    var cards = gridCards();
    var missing = [];
    var seen = new Set();
    var firstOn = -1;
    var i;
    for (i = 0; i < cards.length; i++) {
      if (!cardIntersectsViewport(cards[i])) continue;
      firstOn = i;
      break;
    }
    if (firstOn < 0) return missing;
    for (i = firstOn; i < cards.length; i++) {
      cardSkus(cards[i]).forEach(function (sku) {
        pushMissingSku(missing, seen, known, sku);
      });
      if (missing.length >= SKU_CHUNK) return missing;
    }
    for (i = firstOn - 1; i >= 0; i--) {
      cardSkus(cards[i]).forEach(function (sku) {
        pushMissingSku(missing, seen, known, sku);
      });
      if (missing.length >= SKU_CHUNK) break;
    }
    return missing;
  }

  function observeCards() {
    if (!cardObserver) return;
    document.querySelectorAll('.card-wrapper[data-delivery-skus]').forEach(function (card) {
      if (card.getAttribute('data-w-express-observed') === '1') return;
      card.setAttribute('data-w-express-observed', '1');
      cardObserver.observe(card);
    });
  }

  function tagsOff() {
    return !expressToggleOn();
  }

  function holdGridQuiet() {
    gridQuiet += 1;
    window.setTimeout(function () {
      gridQuiet = Math.max(0, gridQuiet - 1);
    }, 80);
  }

  function setCardExpress(card, statusMap) {
    var row = card.querySelector('[data-w-express-row]');
    if (!row) return;
    var dateEl = row.querySelector('[data-w-express-date]');
    if (tagsOff() && onExpressCollection()) {
      row.classList.remove('is-visible');
      if (dateEl) dateEl.textContent = '';
      return;
    }
    var seen = {};
    var express = cardVariants(card).filter(function (variant) {
      if (!isExpressHours(statusMap[variant.sku])) return false;
      if (seen[variant.size]) return false;
      seen[variant.size] = true;
      return true;
    });
    if (!express.length) {
      row.classList.remove('is-visible');
      if (dateEl) dateEl.textContent = '';
      return;
    }
    if (dateEl) dateEl.textContent = earliestExpressDate(express, statusMap);
    row.classList.add('is-visible');
    if (window.WfwExpressTrack) {
      express.forEach(function (variant) {
        window.WfwExpressTrack.tagged(variant.id);
      });
    }
  }

  function hideAllBadges() {
    document.querySelectorAll('[data-w-express-row]').forEach(function (row) {
      row.classList.remove('is-visible');
      var dateEl = row.querySelector('[data-w-express-date]');
      if (dateEl) dateEl.textContent = '';
    });
  }

  function cardHasExpress(card, statusMap) {
    return cardVariants(card).some(function (variant) {
      return isExpressHours(statusMap[variant.sku]);
    });
  }

  function clearExpressFilter() {
    document.querySelectorAll('.w-express-filtered-out').forEach(function (item) {
      item.classList.remove('w-express-filtered-out');
    });
  }

  function cardGridItem(card) {
    return card.closest('.grid__item') || card.closest('li') || card;
  }

  function onExpressCollection() {
    return !!(document.body && document.body.classList.contains('w-express-delivery'));
  }

  function stampGridOrder(parent) {
    var max = -1;
    Array.prototype.forEach.call(parent.children, function (el) {
      if (!el.getAttribute) return;
      var stamped = el.getAttribute('data-w-express-order');
      if (stamped !== null && stamped !== '') max = Math.max(max, Number(stamped));
    });
    Array.prototype.forEach.call(parent.children, function (el) {
      if (!el.querySelector || !el.querySelector('.card-wrapper[data-delivery-skus]')) return;
      if (el.getAttribute('data-w-express-order') !== null) return;
      max += 1;
      el.setAttribute('data-w-express-order', String(max));
    });
  }

  function placeProducts(parent, sorted) {
    var products = [];
    Array.prototype.forEach.call(parent.children, function (el) {
      if (el.querySelector && el.querySelector('.card-wrapper[data-delivery-skus]')) products.push(el);
    });
    if (products.length < 2 || sorted.length !== products.length) return;
    var same = sorted.every(function (el, i) { return el === products[i]; });
    if (same) return;
    var marks = products.map(function (el) {
      var mark = document.createComment('');
      parent.insertBefore(mark, el);
      return mark;
    });
    sorted.forEach(function (el, i) {
      parent.insertBefore(el, marks[i]);
      parent.removeChild(marks[i]);
    });
  }

  function itemFullyKnown(el, known) {
    var card = el.querySelector && el.querySelector('.card-wrapper[data-delivery-skus]');
    if (!card || !known) return false;
    var skus = cardSkus(card);
    return skus.length > 0 && skus.every(function (sku) { return known.has(sku); });
  }

  function sortProductGroup(parent, expressFirst, expressItems, known) {
    stampGridOrder(parent);
    var products = [];
    Array.prototype.forEach.call(parent.children, function (el) {
      if (el.querySelector && el.querySelector('.card-wrapper[data-delivery-skus]')) products.push(el);
    });
    var sorted = products.slice().sort(function (a, b) {
      var ao = Number(a.getAttribute('data-w-express-order')) || 0;
      var bo = Number(b.getAttribute('data-w-express-order')) || 0;
      if (expressFirst && itemFullyKnown(a, known) && itemFullyKnown(b, known)) {
        var ae = expressItems.has(a) ? 0 : 1;
        var be = expressItems.has(b) ? 0 : 1;
        if (ae !== be) return ae - be;
      }
      return ao - bo;
    });
    placeProducts(parent, sorted);
  }

  function gridItemHandle(el) {
    if (!el || !el.getAttribute) return '';
    var marked = el.getAttribute('data-helium-product-handle') || el.getAttribute('data-w-express-handle');
    if (marked) return marked;
    var link = el.querySelector && el.querySelector('a[href*="/products/"]');
    if (!link) return '';
    var cut = String(link.getAttribute('href') || '').split('/products/')[1] || '';
    return cut.split('?')[0].split('/')[0];
  }

  function dedupeGrid(grid) {
    if (!grid) return;
    var seen = {};
    Array.prototype.slice.call(grid.children).forEach(function (el) {
      var handle = gridItemHandle(el);
      if (!handle) return;
      var prev = seen[handle];
      if (!prev) {
        seen[handle] = el;
        return;
      }
      var drop = el.getAttribute('data-w-express-lifted') ? el : prev;
      if (drop === prev) seen[handle] = el;
      if (drop.parentNode) drop.parentNode.removeChild(drop);
    });
  }

  function applyExpressFilter(cards, statusMap, known) {
    dedupeGrid(document.getElementById('product-grid'));
    var filtering = expressToggleOn();
    var onlyExpress = filtering && onExpressCollection();
    var groups = new Map();
    cards.forEach(function (card) {
      var item = cardGridItem(card);
      var parent = item && item.parentElement;
      if (!parent) return;
      if (!groups.has(parent)) groups.set(parent, []);
      groups.get(parent).push({ card: card, item: item });
    });
    if (onlyExpress) {
      var anyExpress = false;
      var hideItems = [];
      groups.forEach(function (entries, parent) {
        if (parent.closest && parent.closest('.slick-slider')) return;
        entries.forEach(function (entry) {
          var skus = cardSkus(entry.card);
          if (!skus.length) return;
          if (cardHasExpress(entry.card, statusMap)) anyExpress = true;
          else if (skus.every(function (sku) { return known.has(sku); })) hideItems.push(entry.item);
        });
      });
      if (!anyExpress) return;
      hideItems.forEach(function (item) {
        item.classList.add('w-express-filtered-out');
      });
      return;
    }
    groups.forEach(function (entries, parent) {
      if (parent.closest && parent.closest('.slick-slider')) return;
      var expressItems = new Set();
      entries.forEach(function (entry) {
        if (cardHasExpress(entry.card, statusMap)) expressItems.add(entry.item);
      });
      sortProductGroup(parent, filtering && expressItems.size > 0, expressItems, known);
    });
  }

  function fetchSkuChunk(skus, pin) {
    var key = pin + '::' + skus.join(',');
    if (chunkFlights[key]) return chunkFlights[key];
    var promise = (async function () {
      var attempt;
      for (attempt = 0; attempt < 2; attempt++) {
        try {
          var url = new URL(API_BASE);
          url.searchParams.set('skus', skus.join(','));
          url.searchParams.set('deliveryPostcode', pin);
          url.searchParams.set('shop', SHOP_DOMAIN);
          var res = await fetch(url.toString(), { cache: 'no-store' });
          if (!res.ok) throw new Error('status');
          var json = await res.json();
          if (!json || !json.successful || !Array.isArray(json.results)) {
            throw new Error('status');
          }
          var map = {};
          json.results.forEach(function (row) {
            if (!row.productSku) return;
            map[String(row.productSku)] = {
              totalHours: row.totalHours,
              deliveryType: row.deliveryType,
              estimatedDeliveryDate: row.estimatedDeliveryDate || '',
            };
          });
          skus.forEach(function (sku) {
            writeSkuCache(pin, sku, map[sku] || null);
          });
          return map;
        } catch (e) {
          if (attempt < 1) {
            await new Promise(function (resolve) {
              setTimeout(resolve, 1500);
            });
          }
        }
      }
      return null;
    })();
    chunkFlights[key] = promise;
    promise.then(
      function () {
        delete chunkFlights[key];
      },
      function () {
        delete chunkFlights[key];
      }
    );
    return promise;
  }

  function expressToggleOn() {
    if (!readStoredPin()) return false;
    try {
      if (localStorage.getItem('WfwExpressOn') === '1') return true;
    } catch (e) {}
    if (!onExpressCollection()) return false;
    return !window.WfwExpressCollectionHoldOff;
  }

  function cachedCardState(pin, cards) {
    var statusMap = {};
    var known = new Set();
    cards.forEach(function (card) {
      cardSkus(card).forEach(function (sku) {
        if (known.has(sku)) return;
        var cached = readSkuCache(pin, sku);
        if (!cached) return;
        known.add(sku);
        if (cached.value) statusMap[sku] = cached.value;
      });
    });
    return { statusMap: statusMap, known: known };
  }

  function paintKnownCards(cards, statusMap, known) {
    holdGridQuiet();
    cards.forEach(function (card) {
      var skus = cardSkus(card);
      var allKnown = skus.length > 0 && skus.every(function (sku) { return known.has(sku); });
      var anyExpress = skus.some(function (sku) { return isExpressHours(statusMap[sku]); });
      if (allKnown || anyExpress) setCardExpress(card, statusMap);
    });
    applyExpressFilter(cards, statusMap, known);
  }

  async function paintCardBadges() {
    var generation = ++badgeRun;
    var pin = readStoredPin();
    var cards = Array.from(document.querySelectorAll('.card-wrapper[data-delivery-skus]'));
    if (!pin) {
      hideAllBadges();
      clearExpressFilter();
      return;
    }
    if (tagsOff() && onExpressCollection()) {
      hideAllBadges();
      clearExpressFilter();
      holdGridQuiet();
      applyExpressFilter(cards, {}, new Set());
      return;
    }

    var state = cachedCardState(pin, cards);
    var needs = screenNeedsFetch(state.known);
    var chunk = needs ? missingFromScreen(state.known) : [];
    paintKnownCards(cards, state.statusMap, state.known);
    if (!chunk.length) return;

    chunk.forEach(function (sku) { pendingSkus.add(sku); });
    var chunkMap = null;
    try {
      chunkMap = await fetchSkuChunk(chunk, pin);
    } finally {
      chunk.forEach(function (sku) { pendingSkus.delete(sku); });
    }
    if (generation !== badgeRun || readStoredPin() !== pin) return;
    if (!chunkMap) return;

    cards = Array.from(document.querySelectorAll('.card-wrapper[data-delivery-skus]'));
    state = cachedCardState(pin, cards);
    paintKnownCards(cards, state.statusMap, state.known);
    if (screenNeedsFetch(state.known)) badgeAgain = true;
  }

  function scheduleCardBadges(delay) {
    if (holdProductBadges) return;
    observeCards();
    if (badgeTimer) window.clearTimeout(badgeTimer);
    badgeTimer = window.setTimeout(function () {
      badgeTimer = 0;
      if (badgeRunning) {
        badgeAgain = true;
        return;
      }
      badgeRunning = true;
      badgeAgain = false;
      paintCardBadges().then(
        function () {},
        function () {}
      ).then(function () {
        badgeRunning = false;
        if (badgeAgain) scheduleCardBadges(COALESCE_MS);
      });
    }, delay == null ? COALESCE_MS : delay);
  }

  function watchLateCards() {
    if (typeof MutationObserver === 'undefined') return;
    document.querySelectorAll('.product-grid, product-recommendations, recently-viewed-products, cart-recommendations').forEach(function (root) {
      if (root.getAttribute('data-w-express-watch') === '1') return;
      root.setAttribute('data-w-express-watch', '1');
      new MutationObserver(function (mutations) {
        if (gridQuiet) return;
        var structural = mutations.some(function (mutation) {
          var target = mutation.target;
          if (!target || !target.closest) return true;
          return !target.closest('[data-w-express-row], .card-wrapper');
        });
        if (!structural) return;
        observeCards();
        scheduleCardBadges();
      }).observe(root, { childList: true, subtree: true });
    });
  }

  var holdProductBadges = document.body.classList.contains('template-product');

  function releaseProductBadgeHold() {
    if (!holdProductBadges || !window.__wfwPdpDeliverySettled) return;
    holdProductBadges = false;
    scheduleCardBadges();
  }

  function init() {
    if ('IntersectionObserver' in window) {
      cardObserver = new IntersectionObserver(function () {
        scheduleCardBadges();
      }, { threshold: 0.01 });
    }
    document.querySelectorAll(ROOT_SEL).forEach(bind);
    if (holdProductBadges && !window.__wfwPdpDeliverySettled) {
      document.addEventListener('wfw:pdp-delivery-settled', releaseProductBadgeHold, { once: true });
    } else {
      holdProductBadges = false;
    }
    scheduleCardBadges();
    watchLateCards();
    document.addEventListener('wfw:pincode-updated', scheduleCardBadges);
    document.addEventListener('wfw:express-toggle', function () {
      badgeRun += 1;
      pendingSkus.clear();
      if (tagsOff() && onExpressCollection()) {
        hideAllBadges();
        clearExpressFilter();
      }
      scheduleCardBadges(0);
    });
    document.addEventListener('collection:reloaded', scheduleCardBadges);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
/* WFW COLLECTION EXPRESS PIN END */

// /* WFW COLLECTION EXPRESS PIN START */
// (function () {
//   'use strict';

//   if (document.documentElement.classList.contains('h-ab-live')) return;

//   var PIN_KEY = 'ExistPincode';
//   var ROOT_SEL = '[data-collection-express-pin]';
//   var FEATURE_NAME = 'pincode';
//   var FEATURE_ID = 'filter';

//   function isValidPin(pin) {
//     return /^\d{6}$/.test(String(pin || '').trim());
//   }

//   function normalizePin(pin) {
//     return String(pin || '')
//       .replace(/\D/g, '')
//       .slice(0, 6);
//   }

//   function readStoredPin() {
//     var api = window.WFWDeliverySlaApi;
//     if (api && typeof api.getPincode === 'function') {
//       var fromApi = api.getPincode();
//       if (isValidPin(fromApi)) return String(fromApi).trim();
//     }
//     try {
//       var stored = localStorage.getItem(PIN_KEY);
//       if (isValidPin(stored)) return String(stored).trim();
//     } catch (e) {}
//     return null;
//   }

//   function persistPin(pin) {
//     var normalized = normalizePin(pin);
//     if (!isValidPin(normalized)) return false;

//     var api = window.WFWDeliverySlaApi;
//     if (api && typeof api.setPincode === 'function') {
//       return !!api.setPincode(normalized);
//     }

//     try {
//       localStorage.setItem(PIN_KEY, normalized);
//     } catch (e) {}
//     document.dispatchEvent(
//       new CustomEvent('wfw:pincode-updated', { detail: { pincode: normalized } })
//     );
//     return true;
//   }

//   function featureTags() {
//     return {
//       name: FEATURE_NAME,
//       id: FEATURE_ID,
//       strategyId: FEATURE_ID,
//       variant: 'variant',
//       source: 'custom-liquid',
//       sectionId: 'collection-express-pin',
//     };
//   }

//   function stampFeatureParams() {
//     var tags = featureTags();
//     var tracking = window.HeliumUtils && window.HeliumUtils.tracking;
//     if (tracking && typeof tracking.appendFeatureParams === 'function') {
//       try {
//         var next = tracking.appendFeatureParams(window.location.href, tags);
//         if (next && next !== window.location.pathname + window.location.search + window.location.hash) {
//           window.history.replaceState({}, '', next);
//         }
//       } catch (e) {}
//     }
//   }

//   function cacheEls(root) {
//     return {
//       root: root,
//       idle: root.querySelector('[data-express-pin-view="idle"]'),
//       edit: root.querySelector('[data-express-pin-view="edit"]'),
//       set: root.querySelector('[data-express-pin-view="set"]'),
//       input: root.querySelector('#collection-express-pin-input'),
//       value: root.querySelector('[data-express-pin-value]'),
//       error: root.querySelector('[data-express-pin-error]'),
//     };
//   }

//   function setMode(ui, mode) {
//     var views = { idle: ui.idle, edit: ui.edit, set: ui.set };
//     Object.keys(views).forEach(function (key) {
//       if (!views[key]) return;
//       if (key === mode) views[key].removeAttribute('hidden');
//       else views[key].setAttribute('hidden', '');
//     });
//     ui.root.setAttribute('data-express-pin-mode', mode);
//     hideError(ui);
//   }

//   function showError(ui, message) {
//     if (!ui.error) return;
//     ui.error.textContent = message || '';
//     ui.error.hidden = !message;
//   }

//   function hideError(ui) {
//     showError(ui, '');
//   }

//   function paintSet(ui, pin) {
//     if (ui.value) ui.value.textContent = pin;
//     if (ui.input) ui.input.value = pin;
//     ui.root.setAttribute('data-express-pin-current', pin);
//     setMode(ui, 'set');
//   }

//   function paintIdle(ui) {
//     ui.root.removeAttribute('data-express-pin-current');
//     if (ui.input) ui.input.value = '';
//     setMode(ui, 'idle');
//   }

//   function openEdit(ui, existing) {
//     setMode(ui, 'edit');
//     if (ui.input) {
//       ui.input.value = existing || '';
//       window.requestAnimationFrame(function () {
//         ui.input.focus();
//         ui.input.select();
//       });
//     }
//   }

//   function saveFromInput(ui) {
//     var pin = normalizePin(ui.input && ui.input.value);
//     if (ui.input && ui.input.value !== pin) ui.input.value = pin;
//     if (!isValidPin(pin)) {
//       showError(ui, 'Please enter a valid 6 digit pincode');
//       return false;
//     }
//     if (window.WfwExpressTrack) window.WfwExpressTrack.pin(pin, 'collection_pin');
//     if (!persistPin(pin)) {
//       showError(ui, 'Could not save pincode. Try again.');
//       return false;
//     }
//     paintSet(ui, pin);
//     stampFeatureParams();
//     return true;
//   }

//   function bind(root) {
//     if (!root || root.getAttribute('data-express-pin-ready') === '1') return;
//     root.setAttribute('data-express-pin-ready', '1');

//     var ui = cacheEls(root);
//     if (!ui.input) return;

//     var stored = readStoredPin();
//     if (stored) paintSet(ui, stored);
//     else paintIdle(ui);

//     root.addEventListener('click', function (event) {
//       var btn = event.target.closest('[data-express-pin-action]');
//       if (!btn || !root.contains(btn)) return;
//       var action = btn.getAttribute('data-express-pin-action');
//       if (action === 'open' || action === 'change') {
//         openEdit(ui, ui.root.getAttribute('data-express-pin-current') || '');
//       } else if (action === 'save') {
//         saveFromInput(ui);
//       } else if (action === 'cancel') {
//         var current = ui.root.getAttribute('data-express-pin-current');
//         if (isValidPin(current)) paintSet(ui, current);
//         else paintIdle(ui);
//       }
//     });

//     ui.input.addEventListener('input', function () {
//       var pin = normalizePin(ui.input.value);
//       if (ui.input.value !== pin) ui.input.value = pin;
//       hideError(ui);
//       if (pin.length === 6) saveFromInput(ui);
//     });

//     ui.input.addEventListener('keydown', function (event) {
//       if (event.key === 'Enter') {
//         event.preventDefault();
//         saveFromInput(ui);
//       } else if (event.key === 'Escape') {
//         var current = ui.root.getAttribute('data-express-pin-current');
//         if (isValidPin(current)) paintSet(ui, current);
//         else paintIdle(ui);
//       }
//     });

//     document.addEventListener('wfw:pincode-updated', function (event) {
//       if (ui.root.getAttribute('data-express-pin-mode') === 'edit' && document.activeElement === ui.input) {
//         return;
//       }
//       var next =
//         event && event.detail && isValidPin(event.detail.pincode)
//           ? String(event.detail.pincode).trim()
//           : readStoredPin();
//       if (next) paintSet(ui, next);
//       else paintIdle(ui);
//     });
//   }

//   /* Card badges — w-express-badge.svg when any in-stock SKU is under 24h */
//   var API_BASE = window.WfwDeliveryStatusUrl;
//   /* LIVE status host is snippets/delivery-status-url.liquid
//   var API_BASE = 'https://impulse-backend.heliumbuilder.com/api/delivery/status';
//   */
//   var SHOP_DOMAIN = 'shopforw.myshopify.com';
//   var SKU_CHUNK = 60;
//   var COALESCE_MS = 400;
//   var CACHE_TTL = 5 * 60 * 1000;
//   var SESSION_SKU_PREFIX = 'WfwSkuStatus:v2:';
//   var badgeRun = 0;
//   var badgeTimer = 0;
//   var badgeRunning = false;
//   var badgeAgain = false;
//   var gridQuiet = 0;
//   var chunkFlights = {};
//   var cardObserver = null;
//   var pendingSkus = new Set();

//   function skuKey(pin, sku) {
//     return String(pin) + '::' + String(sku);
//   }

//   function readSkuCache(pin, sku) {
//     var key = SESSION_SKU_PREFIX + skuKey(pin, sku);
//     try {
//       var raw = sessionStorage.getItem(key);
//       if (!raw) return null;
//       var parsed = JSON.parse(raw);
//       if (!parsed || Date.now() - parsed.ts >= CACHE_TTL) {
//         sessionStorage.removeItem(key);
//         return null;
//       }
//       if (parsed.checked === true || parsed.value) return parsed;
//       sessionStorage.removeItem(key);
//       return null;
//     } catch (e) {
//       return null;
//     }
//   }

//   function writeSkuCache(pin, sku, value) {
//     try {
//       sessionStorage.setItem(
//         SESSION_SKU_PREFIX + skuKey(pin, sku),
//         JSON.stringify({ ts: Date.now(), checked: true, value: value || null })
//       );
//     } catch (e) {}
//   }

//   function cardSkus(card) {
//     return String(card.getAttribute('data-delivery-skus') || '')
//       .split(',')
//       .map(function (s) {
//         return String(s || '').trim();
//       })
//       .filter(Boolean);
//   }

//   function isExpressHours(info) {
//     if (!info) return false;
//     var type = String(info.deliveryType || '');
//     if (type === 'SDD' || type === 'NDD') return true;
//     var hours = Number(info.totalHours);
//     return isFinite(hours) && hours <= 48;
//   }

//   function cardVariants(card) {
//     return String(card.getAttribute('data-delivery-variants') || '')
//       .split('||')
//       .map(function (part) {
//         var bits = String(part || '').split('~');
//         if (!bits[0] || bits.length < 3) return null;
//         return { sku: bits[0], size: bits[1], id: bits[2] };
//       })
//       .filter(Boolean);
//   }

//   function productPath(card) {
//     var link = card.querySelector('a.card-information__text');
//     if (!link) return '';
//     return String(link.getAttribute('href') || '').split('?')[0];
//   }

//   function escapeHtml(value) {
//     return String(value)
//       .replace(/&/g, '&amp;')
//       .replace(/</g, '&lt;')
//       .replace(/>/g, '&gt;')
//       .replace(/"/g, '&quot;');
//   }

//   var DELIVERY_MONTHS = [
//     'January', 'February', 'March', 'April', 'May', 'June',
//     'July', 'August', 'September', 'October', 'November', 'December'
//   ];

//   function formatDeliveryDate(iso) {
//     var parts = String(iso || '').split('-');
//     if (parts.length < 3) return '';
//     var month = Number(parts[1]);
//     var day = Number(parts[2]);
//     if (!month || month > 12 || !day) return '';
//     return DELIVERY_MONTHS[month - 1] + ' ' + day;
//   }

//   function earliestExpressDate(variants, statusMap) {
//     var earliest = '';
//     variants.forEach(function (variant) {
//       var info = statusMap[variant.sku];
//       var iso = info && info.estimatedDeliveryDate;
//       if (!iso) return;
//       if (!earliest || String(iso) < earliest) earliest = String(iso);
//     });
//     return formatDeliveryDate(earliest);
//   }

//   function cardIntersectsViewport(card) {
//     if (!card || !card.getBoundingClientRect) return false;
//     var rect = card.getBoundingClientRect();
//     if (rect.width < 1 && rect.height < 1) return false;
//     return rect.bottom > 0 && rect.top < window.innerHeight && rect.right > 0 && rect.left < window.innerWidth;
//   }

//   function gridCards() {
//     var scoped = document.querySelectorAll('#product-grid .card-wrapper[data-delivery-skus], .product-grid .card-wrapper[data-delivery-skus]');
//     if (scoped.length) return Array.from(scoped);
//     return Array.from(document.querySelectorAll('.card-wrapper[data-delivery-skus]'));
//   }

//   function screenNeedsFetch(known) {
//     return gridCards().some(function (card) {
//       if (!cardIntersectsViewport(card)) return false;
//       return cardSkus(card).some(function (sku) {
//         return !known.has(sku) && !pendingSkus.has(sku);
//       });
//     });
//   }

//   function pushMissingSku(missing, seen, known, sku) {
//     if (missing.length >= SKU_CHUNK) return;
//     if (!sku || seen.has(sku) || known.has(sku) || pendingSkus.has(sku)) return;
//     seen.add(sku);
//     missing.push(sku);
//   }

//   function missingFromScreen(known) {
//     var cards = gridCards();
//     var missing = [];
//     var seen = new Set();
//     var firstOn = -1;
//     var i;
//     for (i = 0; i < cards.length; i++) {
//       if (!cardIntersectsViewport(cards[i])) continue;
//       firstOn = i;
//       break;
//     }
//     if (firstOn < 0) return missing;
//     for (i = firstOn; i < cards.length; i++) {
//       cardSkus(cards[i]).forEach(function (sku) {
//         pushMissingSku(missing, seen, known, sku);
//       });
//       if (missing.length >= SKU_CHUNK) return missing;
//     }
//     for (i = firstOn - 1; i >= 0; i--) {
//       cardSkus(cards[i]).forEach(function (sku) {
//         pushMissingSku(missing, seen, known, sku);
//       });
//       if (missing.length >= SKU_CHUNK) break;
//     }
//     return missing;
//   }

//   function observeCards() {
//     if (!cardObserver) return;
//     document.querySelectorAll('.card-wrapper[data-delivery-skus]').forEach(function (card) {
//       if (card.getAttribute('data-w-express-observed') === '1') return;
//       card.setAttribute('data-w-express-observed', '1');
//       cardObserver.observe(card);
//     });
//   }

//   function tagsOff() {
//     return !expressToggleOn();
//   }

//   function holdGridQuiet() {
//     gridQuiet += 1;
//     window.setTimeout(function () {
//       gridQuiet = Math.max(0, gridQuiet - 1);
//     }, 80);
//   }

//   function setCardExpress(card, statusMap) {
//     var row = card.querySelector('[data-w-express-row]');
//     if (!row) return;
//     var dateEl = row.querySelector('[data-w-express-date]');
//     if (tagsOff() && onExpressCollection()) {
//       row.classList.remove('is-visible');
//       if (dateEl) dateEl.textContent = '';
//       return;
//     }
//     var seen = {};
//     var express = cardVariants(card).filter(function (variant) {
//       if (!isExpressHours(statusMap[variant.sku])) return false;
//       if (seen[variant.size]) return false;
//       seen[variant.size] = true;
//       return true;
//     });
//     if (!express.length) {
//       row.classList.remove('is-visible');
//       if (dateEl) dateEl.textContent = '';
//       return;
//     }
//     if (dateEl) dateEl.textContent = earliestExpressDate(express, statusMap);
//     row.classList.add('is-visible');
//     if (window.WfwExpressTrack) {
//       express.forEach(function (variant) {
//         window.WfwExpressTrack.tagged(variant.id);
//       });
//     }
//   }

//   function hideAllBadges() {
//     document.querySelectorAll('[data-w-express-row]').forEach(function (row) {
//       row.classList.remove('is-visible');
//       var dateEl = row.querySelector('[data-w-express-date]');
//       if (dateEl) dateEl.textContent = '';
//     });
//   }

//   function cardHasExpress(card, statusMap) {
//     return cardVariants(card).some(function (variant) {
//       return isExpressHours(statusMap[variant.sku]);
//     });
//   }

//   function clearExpressFilter() {
//     document.querySelectorAll('.w-express-filtered-out').forEach(function (item) {
//       item.classList.remove('w-express-filtered-out');
//     });
//   }

//   function cardGridItem(card) {
//     return card.closest('.grid__item') || card.closest('li') || card;
//   }

//   function onExpressCollection() {
//     return !!(document.body && document.body.classList.contains('w-express-delivery'));
//   }

//   function stampGridOrder(parent) {
//     var max = -1;
//     Array.prototype.forEach.call(parent.children, function (el) {
//       if (!el.getAttribute) return;
//       var stamped = el.getAttribute('data-w-express-order');
//       if (stamped !== null && stamped !== '') max = Math.max(max, Number(stamped));
//     });
//     Array.prototype.forEach.call(parent.children, function (el) {
//       if (!el.querySelector || !el.querySelector('.card-wrapper[data-delivery-skus]')) return;
//       if (el.getAttribute('data-w-express-order') !== null) return;
//       max += 1;
//       el.setAttribute('data-w-express-order', String(max));
//     });
//   }

//   function placeProducts(parent, sorted) {
//     var products = [];
//     Array.prototype.forEach.call(parent.children, function (el) {
//       if (el.querySelector && el.querySelector('.card-wrapper[data-delivery-skus]')) products.push(el);
//     });
//     if (products.length < 2 || sorted.length !== products.length) return;
//     var same = sorted.every(function (el, i) { return el === products[i]; });
//     if (same) return;
//     var marks = products.map(function (el) {
//       var mark = document.createComment('');
//       parent.insertBefore(mark, el);
//       return mark;
//     });
//     sorted.forEach(function (el, i) {
//       parent.insertBefore(el, marks[i]);
//       parent.removeChild(marks[i]);
//     });
//   }

//   function itemFullyKnown(el, known) {
//     var card = el.querySelector && el.querySelector('.card-wrapper[data-delivery-skus]');
//     if (!card || !known) return false;
//     var skus = cardSkus(card);
//     return skus.length > 0 && skus.every(function (sku) { return known.has(sku); });
//   }

//   function sortProductGroup(parent, expressFirst, expressItems, known) {
//     stampGridOrder(parent);
//     var products = [];
//     Array.prototype.forEach.call(parent.children, function (el) {
//       if (el.querySelector && el.querySelector('.card-wrapper[data-delivery-skus]')) products.push(el);
//     });
//     var sorted = products.slice().sort(function (a, b) {
//       var ao = Number(a.getAttribute('data-w-express-order')) || 0;
//       var bo = Number(b.getAttribute('data-w-express-order')) || 0;
//       if (expressFirst && itemFullyKnown(a, known) && itemFullyKnown(b, known)) {
//         var ae = expressItems.has(a) ? 0 : 1;
//         var be = expressItems.has(b) ? 0 : 1;
//         if (ae !== be) return ae - be;
//       }
//       return ao - bo;
//     });
//     placeProducts(parent, sorted);
//   }

//   function gridItemHandle(el) {
//     if (!el || !el.getAttribute) return '';
//     var marked = el.getAttribute('data-helium-product-handle') || el.getAttribute('data-w-express-handle');
//     if (marked) return marked;
//     var link = el.querySelector && el.querySelector('a[href*="/products/"]');
//     if (!link) return '';
//     var cut = String(link.getAttribute('href') || '').split('/products/')[1] || '';
//     return cut.split('?')[0].split('/')[0];
//   }

//   function dedupeGrid(grid) {
//     if (!grid) return;
//     var seen = {};
//     Array.prototype.slice.call(grid.children).forEach(function (el) {
//       var handle = gridItemHandle(el);
//       if (!handle) return;
//       var prev = seen[handle];
//       if (!prev) {
//         seen[handle] = el;
//         return;
//       }
//       var drop = el.getAttribute('data-w-express-lifted') ? el : prev;
//       if (drop === prev) seen[handle] = el;
//       if (drop.parentNode) drop.parentNode.removeChild(drop);
//     });
//   }

//   function applyExpressFilter(cards, statusMap, known) {
//     dedupeGrid(document.getElementById('product-grid'));
//     var filtering = expressToggleOn();
//     var onlyExpress = filtering && onExpressCollection();
//     var groups = new Map();
//     cards.forEach(function (card) {
//       var item = cardGridItem(card);
//       var parent = item && item.parentElement;
//       if (!parent) return;
//       if (!groups.has(parent)) groups.set(parent, []);
//       groups.get(parent).push({ card: card, item: item });
//     });
//     if (onlyExpress) {
//       var anyExpress = false;
//       var hideItems = [];
//       groups.forEach(function (entries, parent) {
//         if (parent.closest && parent.closest('.slick-slider')) return;
//         entries.forEach(function (entry) {
//           var skus = cardSkus(entry.card);
//           if (!skus.length) return;
//           if (cardHasExpress(entry.card, statusMap)) anyExpress = true;
//           else if (skus.every(function (sku) { return known.has(sku); })) hideItems.push(entry.item);
//         });
//       });
//       if (!anyExpress) return;
//       hideItems.forEach(function (item) {
//         item.classList.add('w-express-filtered-out');
//       });
//       return;
//     }
//     groups.forEach(function (entries, parent) {
//       if (parent.closest && parent.closest('.slick-slider')) return;
//       var expressItems = new Set();
//       entries.forEach(function (entry) {
//         if (cardHasExpress(entry.card, statusMap)) expressItems.add(entry.item);
//       });
//       sortProductGroup(parent, filtering && expressItems.size > 0, expressItems, known);
//     });
//   }

//   function fetchSkuChunk(skus, pin) {
//     var key = pin + '::' + skus.join(',');
//     if (chunkFlights[key]) return chunkFlights[key];
//     var promise = (async function () {
//       var attempt;
//       for (attempt = 0; attempt < 2; attempt++) {
//         try {
//           var url = new URL(API_BASE);
//           url.searchParams.set('skus', skus.join(','));
//           url.searchParams.set('deliveryPostcode', pin);
//           url.searchParams.set('shop', SHOP_DOMAIN);
//           var res = await fetch(url.toString(), { cache: 'no-store' });
//           if (!res.ok) throw new Error('status');
//           var json = await res.json();
//           if (!json || !json.successful || !Array.isArray(json.results)) {
//             throw new Error('status');
//           }
//           var map = {};
//           json.results.forEach(function (row) {
//             if (!row.productSku) return;
//             map[String(row.productSku)] = {
//               totalHours: row.totalHours,
//               deliveryType: row.deliveryType,
//               estimatedDeliveryDate: row.estimatedDeliveryDate || '',
//             };
//           });
//           skus.forEach(function (sku) {
//             writeSkuCache(pin, sku, map[sku] || null);
//           });
//           return map;
//         } catch (e) {
//           if (attempt < 1) {
//             await new Promise(function (resolve) {
//               setTimeout(resolve, 1500);
//             });
//           }
//         }
//       }
//       return null;
//     })();
//     chunkFlights[key] = promise;
//     promise.then(
//       function () {
//         delete chunkFlights[key];
//       },
//       function () {
//         delete chunkFlights[key];
//       }
//     );
//     return promise;
//   }

//   function expressToggleOn() {
//     if (!readStoredPin()) return false;
//     try {
//       if (localStorage.getItem('WfwExpressOn') === '1') return true;
//     } catch (e) {}
//     if (!onExpressCollection()) return false;
//     return !window.WfwExpressCollectionHoldOff;
//   }

//   function cachedCardState(pin, cards) {
//     var statusMap = {};
//     var known = new Set();
//     cards.forEach(function (card) {
//       cardSkus(card).forEach(function (sku) {
//         if (known.has(sku)) return;
//         var cached = readSkuCache(pin, sku);
//         if (!cached) return;
//         known.add(sku);
//         if (cached.value) statusMap[sku] = cached.value;
//       });
//     });
//     return { statusMap: statusMap, known: known };
//   }

//   function paintKnownCards(cards, statusMap, known) {
//     holdGridQuiet();
//     cards.forEach(function (card) {
//       var skus = cardSkus(card);
//       var allKnown = skus.length > 0 && skus.every(function (sku) { return known.has(sku); });
//       var anyExpress = skus.some(function (sku) { return isExpressHours(statusMap[sku]); });
//       if (allKnown || anyExpress) setCardExpress(card, statusMap);
//     });
//     applyExpressFilter(cards, statusMap, known);
//   }

//   async function paintCardBadges() {
//     var generation = ++badgeRun;
//     var pin = readStoredPin();
//     var cards = Array.from(document.querySelectorAll('.card-wrapper[data-delivery-skus]'));
//     if (!pin) {
//       hideAllBadges();
//       clearExpressFilter();
//       return;
//     }
//     if (tagsOff() && onExpressCollection()) {
//       hideAllBadges();
//       clearExpressFilter();
//       holdGridQuiet();
//       applyExpressFilter(cards, {}, new Set());
//       return;
//     }

//     var state = cachedCardState(pin, cards);
//     var needs = screenNeedsFetch(state.known);
//     var chunk = needs ? missingFromScreen(state.known) : [];
//     paintKnownCards(cards, state.statusMap, state.known);
//     if (!chunk.length) return;

//     chunk.forEach(function (sku) { pendingSkus.add(sku); });
//     var chunkMap = null;
//     try {
//       chunkMap = await fetchSkuChunk(chunk, pin);
//     } finally {
//       chunk.forEach(function (sku) { pendingSkus.delete(sku); });
//     }
//     if (generation !== badgeRun || readStoredPin() !== pin) return;
//     if (!chunkMap) return;

//     cards = Array.from(document.querySelectorAll('.card-wrapper[data-delivery-skus]'));
//     state = cachedCardState(pin, cards);
//     paintKnownCards(cards, state.statusMap, state.known);
//     if (screenNeedsFetch(state.known)) badgeAgain = true;
//   }

//   function scheduleCardBadges(delay) {
//     if (holdProductBadges) return;
//     observeCards();
//     if (badgeTimer) window.clearTimeout(badgeTimer);
//     badgeTimer = window.setTimeout(function () {
//       badgeTimer = 0;
//       if (badgeRunning) {
//         badgeAgain = true;
//         return;
//       }
//       badgeRunning = true;
//       badgeAgain = false;
//       paintCardBadges().then(
//         function () {},
//         function () {}
//       ).then(function () {
//         badgeRunning = false;
//         if (badgeAgain) scheduleCardBadges(COALESCE_MS);
//       });
//     }, delay == null ? COALESCE_MS : delay);
//   }

//   function watchLateCards() {
//     if (typeof MutationObserver === 'undefined') return;
//     document.querySelectorAll('.product-grid, product-recommendations, recently-viewed-products, cart-recommendations').forEach(function (root) {
//       if (root.getAttribute('data-w-express-watch') === '1') return;
//       root.setAttribute('data-w-express-watch', '1');
//       new MutationObserver(function (mutations) {
//         if (gridQuiet) return;
//         var structural = mutations.some(function (mutation) {
//           var target = mutation.target;
//           if (!target || !target.closest) return true;
//           return !target.closest('[data-w-express-row], .card-wrapper');
//         });
//         if (!structural) return;
//         observeCards();
//         scheduleCardBadges();
//       }).observe(root, { childList: true, subtree: true });
//     });
//   }

//   var holdProductBadges = document.body.classList.contains('template-product');

//   function releaseProductBadgeHold() {
//     if (!holdProductBadges || !window.__wfwPdpDeliverySettled) return;
//     holdProductBadges = false;
//     scheduleCardBadges();
//   }

//   function init() {
//     if ('IntersectionObserver' in window) {
//       cardObserver = new IntersectionObserver(function () {
//         scheduleCardBadges();
//       }, { threshold: 0.01 });
//     }
//     document.querySelectorAll(ROOT_SEL).forEach(bind);
//     if (holdProductBadges && !window.__wfwPdpDeliverySettled) {
//       document.addEventListener('wfw:pdp-delivery-settled', releaseProductBadgeHold, { once: true });
//     } else {
//       holdProductBadges = false;
//     }
//     scheduleCardBadges();
//     watchLateCards();
//     document.addEventListener('wfw:pincode-updated', scheduleCardBadges);
//     document.addEventListener('wfw:express-toggle', function () {
//       badgeRun += 1;
//       pendingSkus.clear();
//       if (tagsOff() && onExpressCollection()) {
//         hideAllBadges();
//         clearExpressFilter();
//       }
//       scheduleCardBadges(0);
//     });
//     document.addEventListener('collection:reloaded', scheduleCardBadges);
//   }

//   if (document.readyState === 'loading') {
//     document.addEventListener('DOMContentLoaded', init);
//   } else {
//     init();
//   }
// })();
// /* WFW COLLECTION EXPRESS PIN END */
